<template>
    <div>
        <modal :name="modal_name" class="final-modal change-status" transition="nice-modal-fade">
            <div class="v-modal-content" style="border-radius: 15px;background:#fff !important;">
                <div class="v-modal-header d-flex align-items-center justify-content-center" style="background:#005dae !important;">
                    <span class="v-modal-dialog-title v-modal-title text-white" style="text-transform:none !important;">TICKET STATUS</span>
                    <div class="position-absolute" style="right: 10px; top: auto;">
                        <span class="icon icon-close mr-2 text-white pointer close-left" @click="hideView"></span>
                    </div>
                </div>
                <div v-if="save_btn_disabled" class="checkoutLoader">
                    <div class="LoaderPlacement">
                         <div class="digi-table-loader">
                              <div></div>
                              <div></div>
                              <div></div>
                              <div></div>
                         </div>
                    </div>
               </div>
                <div class="general-section pt-2 px-4 pb-1" style="background-color:#fff;border-radius:0px">
                    <div class="v-modal-body pt-0 pb-0" style="max-height: 410px;overflow: auto;">
                        <div class="d-form px-2 py-3" style="overflow: initial !important; min-width: 720px;">
                            <h1 class="fs-14 fw-600 text-black pl-10">
                                Status Timeline
                            </h1>
                            <div class="d-flex px-3 justify-content-center py-2">
                                <div class="d-flex justify-content-between" v-for="(item,index) in api_options" :key="index">
                                    <div v-if="item.value && (change_status == item.name)" class="ticket-status-text-blue text-center" :class="{'ticket-status-green':change_status == 'Closed'}" style="width: 170px;">
                                        {{item.name}}
                                    </div>
                                </div>
                                <div class="d-flex justify-content-between" v-for="(item,index) in api_options" :key="index">
                                    <div class="d-flex status-stages" v-if="template_type == 'default' || (template_type == 'multi_part' && item.name != 'Re-Open')">
                                        <div >
                                            <div class="status-stages-line">
                                            </div>
                                            <div class="px-6 adjust-to-top">
                                                <div class="status-stages-circle-inner-padding status-stages-circle-inner-border-blue pointer-event" style="pointer-events: auto;" v-if="item.status == 'active'">
                                                    <div class="status-stages-circle-inner">
                                                        <div class="status-stages-circle-inner-active-blue">
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="status-stages-circle-inner-padding status-stages-circle-inner-border-green pointer-event" style="pointer-events: auto;" v-if="item.status == 'success'">
                                                    <div class="status-stages-circle-inner">
                                                        <div class="status-stages-circle-inner-active-green">
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="status-stages-circle-inner-padding status-stages-circle-inner-border-grey pointer-event" style="pointer-events: auto;" v-if="item.status == 'disabled'">
                                                    <div class="status-stages-circle-inner">
                                                        <div class="status-stages-circle-inner-active-grey">
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="status-stages-circle-inner-padding bg-white pointer"  @click="changeStatusValue(item.name, index)" v-if="item.status == 'enabled'">
                                                    <div class="status-stages-circle-inner">
                                                        <div class="bg-white">
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="pt-2">
                                                    <div class="fs-14" :class="{'status-stages-circle-text-grey':item.status == 'enabled', 'status-stages-circle-text-green':item.status == 'success', 'status-stages-circle-text-blue':item.status == 'active', 'status-stages-circle-text-grey':item.status == 'disabled'}">
                                                        {{item.name}}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="status-change-end">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="v-modal-dialog-actions justify-content-end pr-10" style="border-radius: 0px 0px 15px 15px;">
                        <a class="btn btn-danger btn-smm text-white" style="text-transform: uppercase !important;font-size: 12px !important;" @click="hideView()">CANCEL</a>
                        <button type="button" class="btn btn-success btn-smm text-white ml-4" :class="{'text-align-left' : save_loader}" :disabled="save_btn_disabled || save_loader" @click="save()" style="box-shadow: none;">
                            {{ save_loader ? 'Saving' : 'SAVE'}}
                            <half-circle-spinner v-if='save_loader' :animation-duration="1000" :size="20" color="#00448b" style="top:-25px;left:47px" />
                        </button>
                    </div>
                </div>
            </div>
        </modal>
        <signature-status @updateClosedStatus="updateClosedStatus" modal_name="signature-status" :customer_name="customer_name" :closed_ticket="closed_ticket"></signature-status>
        <sweet-modal ref="success_modal" icon="success">{{success_msg}}</sweet-modal>
        <sweet-modal ref="warning_modal" icon="warning">{{warning_msg}}</sweet-modal>
    </div>
</template>
<script>
import { HalfCircleSpinner } from "epic-spinners";
import ticket from '../mixins/ticket.js';
import { SweetModal } from 'sweet-modal-vue';
const SignatureStatus = () => import("./SignatureStatus");
import { EventBus } from '../eventBus/nav-bar-event.js';
export default {
    props:['modal_name','ticket_id','status','closed_ticket', 'customer_name', 'template_type'],
    mixins:[ticket],
    components:{
        SignatureStatus,
        HalfCircleSpinner,
        SweetModal
    },
    data(){
        return{
            change_status:'',
            success_msg:'',
            warning_msg:'',
            status_validation:[],
            api_options:[],
            customer_survey:false,
            reason:'',
            feedBack:false,
            job_type: '',
            ticket_status: '',
            save_btn_disabled: true,
            save_loader: false,
        }
    },
    methods:{
        cancelReject(){
            this.$modal.show(this.modal_name);
        },
        saveReject(value){
            this.reason = value
            this.$modal.hide('reject-status');
            this.confirmSave()
        },
        hideView(){
            this.change_status = ''
            this.$modal.hide(this.modal_name);
            this.$emit('cancelStatus')
        },
        save(){
            if(this.change_status == 'closed' || this.change_status == 'Closed'){
                this.$modal.hide(this.modal_name);
                setTimeout(() => {
                    this.$modal.show('signature-status');
                }, 500);
            }
            else{
                this.confirmSave()
            }
        },
        async confirmSave(){
            // this.save_btn_disabled = true;
            this.save_loader = true
            try {
                let params ={
                    status:this.change_status,
                    ticket_id:this.ticket_id
                }
                if(params.status == 'reject' || params.status == 'Reject'){
                    params['reason'] = this.reason
                }
                let res = await this.changeStatus(params)
                this.success_msg = res.response
                this.$refs.success_modal.open();
                setTimeout(() => {
                    this.$refs.success_modal.close();
                    this.$modal.hide(this.modal_name);
                    this.change_status = ''
                    EventBus.$emit('RecallNotification')
                    EventBus.$emit('RecallStatusTabs')
                    this.$emit('updateStatus')
                }, 2000);
            } catch (reason) {
                // this.save_btn_disabled = false;
                this.save_loader = false
                this.warning_msg = reason
                this.$refs.warning_modal.open();
                setTimeout(() => {
                    this.$refs.warning_modal.close();
                }, 3000);
            }
        },
        updateClosedStatus(){
            this.change_status = ''
            this.$emit('updateStatus')
        },
        fixedStatus(){
            this.change_status = ''
            this.$emit('updateStatus')
        },
        async getDetails(){
            try {
                this.save_btn_disabled = true
                let params = {
                    ticket_id:this.ticket_id
                } 
                let res = await this.getStatusOfTicket(params)
                this.status_validation = res.response.status_validation
                this.customer_survey = res.response.customer_survey
                this.status_validation.forEach((myArray,index)=>{
                    for (var key in myArray) {
                        this.api_options.push({name:key,value:myArray[key]})
                    }
                })
                this.save_btn_disabled = false
                console.log(this.api_options)
                console.log(this.change_status)
                this.dataDestructure(this.change_status);
            } catch (reason) {
                this.save_btn_disabled = false
            }
        },
        async getJobTypeOfTicket() {
            try {
                let params = {
                    ticket_id:this.ticket_id
                } 
                let res = await this.getTicketById(params)
                this.job_type = res.response.general_details.job_type;
            } catch (reason) {
                
            }
        },
        dataDestructure(value) {
            switch (value) {
                case 'In progress':
                    this.api_options.forEach((myArray,index)=>{
                        switch(myArray.name){
                            case 'In progress':
                                this.api_options[index].status = 'active'
                                break;
                            case 'Closed':
                                this.api_options[index].status = 'disabled'
                                break;
                            case 'Open':
                                this.api_options[index].status = 'success' 
                                break;
                            case 'Re-Open':
                                this.api_options[index].status = 'disabled' 
                                break;
                            case 'Fixed':
                                this.api_options[index].status = 'enabled' 
                                break;
                        };
                    })
                    break;
                case 'Closed':
                    this.api_options.forEach((myArray,index)=>{
                        switch(myArray.name){
                            case 'In progress':
                                this.api_options[index].status = 'success'
                                break;
                            case 'Closed':
                                this.api_options[index].status = 'active'
                                break;
                            case 'Open':
                                this.api_options[index].status = 'success' 
                                break;
                            case 'Re-Open':
                                this.api_options[index].status = 'enabled' 
                                break;
                            case 'Fixed':
                                this.api_options[index].status = 'success' 
                                break;
                        };
                    })
                    break;
                case 'Re-Open':
                    this.api_options.forEach((myArray,index)=>{
                        switch(myArray.name){
                            case 'In progress':
                                this.api_options[index].status = 'enabled'
                                break;
                            case 'Closed':
                                this.api_options[index].status = 'disabled'
                                break;
                            case 'Open':
                                this.api_options[index].status = 'success' 
                                break;
                            case 'Re-Open':
                                this.api_options[index].status = 'active' 
                                break;
                            case 'Fixed':
                                this.api_options[index].status = 'enabled' 
                                break;
                        };
                    })
                    break;
                case 'Fixed':
                    this.api_options.forEach((myArray,index)=>{
                        switch(myArray.name){
                            case 'In progress':
                                this.api_options[index].status = 'success'
                                break;
                            case 'Closed':
                                this.api_options[index].status = 'enabled'
                                break;
                                this.api_options[index].status = 'success' 
                                break;
                            case 'Open':
                                this.api_options[index].status = 'success' 
                                break;
                            case 'Re-Open':
                                this.api_options[index].status = 'enabled' 
                                break;
                            case 'Fixed':
                                this.api_options[index].status = 'active' 
                                break;
                        };
                    })
                    break;
                case 'Open':
                    this.api_options.forEach((myArray,index)=>{
                        switch(myArray.name){
                            case 'In progress':
                                this.api_options[index].status = 'enabled'
                                break;
                            case 'Closed':
                                this.api_options[index].status = 'disabled'
                                break;
                            case 'Open':
                                this.api_options[index].status = 'active' 
                                break;
                            case 'Re-Open':
                                this.api_options[index].status = 'disabled' 
                                break;
                            case 'Fixed':
                                this.api_options[index].status = 'disabled' 
                                break;
                        };
                    })
                    break;
            }
                console.log(this.api_options)

        },
        changeStatusValue(value, index){
            this.change_status = value;
            if(this.ticket_status == value) {
                this.save_btn_disabled = true;
            } else {
                this.save_btn_disabled = false;
            }
            switch (value) {
                case 'In progress':
                    this.api_options.forEach((myArray,index)=>{
                        switch(myArray.name){
                            case 'In progress':
                                this.api_options[index].status = 'active'
                                break;
                            case 'Closed':
                                this.api_options[index].status = 'disabled'
                                break;
                            case 'Open':
                                if(this.ticket_status == 'In progress'){
                                    this.api_options[index].status = 'success' 
                                } else if(this.ticket_status == 'Re-Open'){
                                    this.api_options[index].status = 'success' 
                                } else {
                                    this.api_options[index].status = 'enabled' 
                                }
                                break;
                            case 'Re-Open':
                                if(this.ticket_status == 'Re-Open'){
                                    this.api_options[index].status = 'enabled' 
                                } else {
                                    this.api_options[index].status = 'disabled' 
                                }
                                break;
                            case 'Fixed':
                                if(this.ticket_status == 'In progress'){
                                    this.api_options[index].status = 'enabled' 
                                } else if(this.ticket_status == 'Re-Open'){
                                    this.api_options[index].status = 'enabled' 
                                } else {
                                    this.api_options[index].status = 'disabled' 
                                }
                                break;
                        };
                    })
                    break;
                case 'Closed':
                    this.api_options.forEach((myArray,index)=>{
                        switch(myArray.name){
                            case 'In progress':
                                this.api_options[index].status = 'success'
                                break;
                            case 'Closed':
                                this.api_options[index].status = 'active'
                                break;
                            case 'Open':
                                this.api_options[index].status = 'success' 
                                break;
                            case 'Re-Open':
                                if(this.ticket_status == 'Fixed'){
                                    this.api_options[index].status = 'enabled' 
                                } else if(this.ticket_status == 'Closed') {
                                    this.api_options[index].status = 'enabled' 
                                } else {
                                    this.api_options[index].status = 'disabled' 
                                }
                                break;
                            case 'Fixed':
                                if(this.ticket_status == 'Fixed'){
                                    this.api_options[index].status = 'enabled' 
                                } else if(this.ticket_status == 'Closed') {
                                    this.api_options[index].status = 'success';
                                } else {
                                    this.api_options[index].status = 'disabled' 
                                }
                                break;
                        };
                    })
                    break;
                case 'Re-Open':
                    this.api_options.forEach((myArray,index)=>{
                        switch(myArray.name){
                            case 'In progress':
                                if(this.ticket_status == 'Re-Open'){
                                    this.api_options[index].status = 'enabled' 
                                } else {
                                    this.api_options[index].status = 'success'
                                }
                                break;
                            case 'Closed':
                                if(this.ticket_status == 'Re-Open'){
                                    this.api_options[index].status = 'disabled' 
                                } else {
                                    this.api_options[index].status = 'enabled'
                                }
                                break;
                            case 'Open':
                                this.api_options[index].status = 'success' 
                                break;
                            case 'Re-Open':
                                if(this.ticket_status == 'Closed'){
                                    this.api_options[index].status = 'active' 
                                } else if(this.ticket_status == 'Re-Open'){
                                    this.api_options[index].status = 'active' 
                                } else if(this.ticket_status == 'Fixed'){
                                    this.api_options[index].status = 'active' 
                                } else {
                                    this.api_options[index].status = 'enabled' 
                                }
                                break;
                            case 'Fixed':
                                if(this.ticket_status == 'Closed'){
                                    this.api_options[index].status = 'success' 
                                } else if(this.ticket_status == 'Re-Open'){
                                    this.api_options[index].status = 'enabled' 
                                } else {
                                    this.api_options[index].status = 'enabled' 
                                }
                                break;
                        };
                    })
                    break;
                case 'Fixed':
                    this.api_options.forEach((myArray,index)=>{
                        switch(myArray.name){
                            case 'In progress':
                                if(this.ticket_status == 'Fixed'){
                                    this.api_options[index].status = 'success' 
                                } else if(this.ticket_status == 'Re-Open'){
                                    this.api_options[index].status = 'enabled' 
                                } else {
                                    this.api_options[index].status = 'enabled' 
                                }
                                break;
                            case 'Closed':
                                if(this.ticket_status == 'Re-Open'){
                                    this.api_options[index].status = 'disabled' 
                                } else if(this.ticket_status == 'In progress'){
                                    this.api_options[index].status = 'disabled' 
                                } else {
                                    this.api_options[index].status = 'enabled'
                                }
                                break;
                            case 'Open':
                                this.api_options[index].status = 'success' 
                                break;
                            case 'Re-Open':
                                if(this.ticket_status == 'In progress'){
                                    this.api_options[index].status = 'disabled' 
                                } else {
                                    this.api_options[index].status = 'enabled' 
                                }
                                break;
                            case 'Fixed':
                                this.api_options[index].status = 'active' 
                                break;
                        };
                    })
                    break;
                case 'Open':
                    this.api_options.forEach((myArray,index)=>{
                        switch(myArray.name){
                            case 'In progress':
                                this.api_options[index].status = 'enabled'
                                break;
                            case 'Closed':
                                this.api_options[index].status = 'disabled'
                                break;
                            case 'Open':
                                this.api_options[index].status = 'active' 
                                break;
                            case 'Re-Open':
                                this.api_options[index].status = 'disabled' 
                                break;
                            case 'Fixed':
                                this.api_options[index].status = 'disabled' 
                                break;
                        };
                    })
                    break;
            }
            this.$forceUpdate();
        }
    },
    mounted(){
        this.getDetails()
        this.getJobTypeOfTicket()
        this.change_status = this.status;
        this.ticket_status = this.status;
    },
    computed:{
        loggedInUser() {
            return this.$store.state.store.loggedInUser
        },
    },
    watch:{
        'status'(newValue,oldValue){
            if(newValue){
                this.change_status = this.status
            }
        }
    }
}
</script>
<style scoped>
    .change-status{
        display: flex;
        flex-direction: column;
    }
    .ticket-status-text-blue {
        padding: 11.3px 46px;
        object-fit: contain;
        color: #fff;
        line-height: 2.2;
        background-image: linear-gradient(to right, #07458b, #0e7efa);
    }
    .ticket-status-green {
        padding: 11.3px 46px;
        object-fit: contain;
        color: #fff;
        line-height: 2.2;
        background-image: linear-gradient(to right, #004532, #008a63);
    }
    .status-stages {

    }
    .status-stages-line {
        height: 2.5px;
        background-color: #c4c4c4;
        width: 100%;
        /* border: solid 2.5px #c4c4c4; */
    }
    .status-stages-circle-inner {
        height: 20px;
        width: 20px;
        margin: 0 auto;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        /* background-color: #a3a3a3; */
    }
    .status-stages-circle-inner-active-blue {
        height: 100%;
        width: 100%;
        border-radius: 50%;
        background-color: #0a5fbe;
    }
    .status-stages-circle-inner-active-green {
        height: 100%;
        width: 100%;
        border-radius: 50%;
        background-size: contain;
        background-repeat: no-repeat;
        background-image: url('/static/images/status_green.svg');
    }
    .status-stages-circle-inner-active-grey {
        height: 100%;
        width: 100%;
        border-radius: 50%;
        background-color: #c4c4c4;
    }
    .status-change-end {
        background-color: #206ad3;
        width: 7px;
    }
    .status-stages-circle-inner-padding {
        padding: 2px;
        width: 30px;
        background-color: #fff;
        height: 30px;
        margin: 0 auto;
        border: 2.5px solid #a3a3a3;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .status-stages-circle-inner-border-blue {
        border-color: #0a5fbe;
    }
    .status-stages-circle-inner-border-green {
        border-color: #008a63;
    }
    .status-stages-circle-inner-border-grey {
        border-color: #c4c4c4;
        background-color: #c4c4c4;
    }
    .status-stages-circle-text-blue {
        color: #0a5fbe;
    }
    .status-stages-circle-text-green {
        color: #008a63;
    }
    .status-stages-circle-text-grey {
        color: #a3a3a3;
    }
    .adjust-to-top {
        margin-top: -15px;
    }
    .background-color-grey {
        background-color: #a3a3a3;
    }
    .inverse div{
        position: absolute;
        top: 27px;
        width: 11px;
        height: 11px;
        border-radius: 50%;
        background: #fff;
        animation-timing-function: cubic-bezier(0, 1, 1, 0);
    }
    .text-align-left{
        text-align: left !important;
    }
</style>